/* =========================================================
   TORU SPECIALTY COFFEE — Shopify Theme JS
   Cart powered by Shopify Cart AJAX API
   ========================================================= */

/* ---- HERO SLIDER ----
   Slider logic is now in sections/hero.liquid (inline script) so it
   can read section settings (autoplay, interval, mobile height).
   heroGoSlide() and goSlide() are exposed to window by that script. */

/* ---- PRODUCT TABS + PAGINATION ---- */
/* switchTab / renderTabPage / pageTab are defined in featured-products.liquid inline script.
   This stub exists so callers work even before that script loads. */
if (typeof switchTab === 'undefined') {
  window.switchTab = function(name) {};
}

/* ---- SHOPIFY CART API ---- */
function formatRp(cents) {
  return 'Rp ' + Math.round(cents / 100).toLocaleString('id-ID');
}

async function shopifyFetch(url, options) {
  const res = await fetch(url, options);
  if (!res.ok) throw new Error('Shopify API error: ' + res.status);
  return res.json();
}

async function refreshCart() {
  try {
    const cart = await shopifyFetch('/cart.js');
    window._shopifyCart = cart;
    renderCartFromShopify(cart);
  } catch (e) {
    console.error('Cart refresh failed:', e);
  }
}

function renderCartFromShopify(cart) {
  const body    = document.getElementById('cartBody');
  const empty   = document.getElementById('cartEmpty');
  const foot    = document.getElementById('cartFoot');
  const badge   = document.getElementById('cartBadge');
  const totalEl = document.getElementById('cartTotalAmt');
  if (!body) return;

  badge.textContent = cart.item_count;
  badge.classList.toggle('show', cart.item_count > 0);
  empty.style.display = cart.items.length ? 'none' : 'flex';
  foot.classList.toggle('show', cart.items.length > 0);
  totalEl.textContent = formatRp(cart.total_price);

  body.querySelectorAll('.cart-item-row').forEach(el => el.remove());

  cart.items.forEach(item => {
    const div = document.createElement('div');
    div.className = 'cart-item-row';
    // Grind property for coffee; variant title for real-variant products (matcha pouch/can etc.)
    const grind = (item.properties && item.properties['Grind'])
               || (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '');
    // find emoji icon from PRODUCTS lookup
    const p = window.PRODUCTS && Object.values(window.PRODUCTS).find(p => String(p.variantId) === String(item.variant_id));
    const thumb = item.image
      ? `<img src="${item.image}" alt="${item.product_title}" />`
      : (p && p.icon ? p.icon : '☕');

    div.innerHTML = `
      <div class="cart-item-thumb">${thumb}</div>
      <div class="cart-item-info">
        <div class="cart-item-name">${item.product_title}</div>
        ${grind ? `<div class="cart-item-grind">${grind}</div>` : ''}
        <div class="cart-item-sub">${formatRp(item.price)} / item</div>
        <div class="qty-ctrl">
          <button class="qty-btn" onclick="changeCartQty('${item.key}', ${item.quantity - 1})">−</button>
          <span class="qty-num">${item.quantity}</span>
          <button class="qty-btn" onclick="changeCartQty('${item.key}', ${item.quantity + 1})">+</button>
        </div>
      </div>
      <div class="cart-item-price">${formatRp(item.line_price)}</div>`;
    body.appendChild(div);
  });
}

async function changeCartQty(lineKey, qty) {
  try {
    await shopifyFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: qty })
    });
    await refreshCart();
  } catch (e) { console.error('Qty change failed:', e); }
}

/* Quick add from product card — adds directly to cart (Whole Bean default), btn = this from onclick */
async function quickAdd(handle, btn) {
  const p = window.PRODUCTS && window.PRODUCTS[handle];
  if (!p || !p.variantId) { console.warn('quickAdd: no variantId for', handle); return; }
  const origText = btn ? btn.textContent : '';
  if (btn) { btn.textContent = '...'; btn.disabled = true; }
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: p.variantId, quantity: 1, properties: { Grind: 'Whole Bean' } })
    });
    if (!res.ok) throw new Error('Add failed ' + res.status);
    await res.json();
    if (btn) { btn.textContent = '✓ Added'; setTimeout(() => { btn.textContent = origText; btn.disabled = false; }, 1400); }
    await refreshCart();
    openCart();
  } catch (e) {
    console.error('Quick add failed:', e);
    if (btn) { btn.textContent = origText; btn.disabled = false; }
  }
}

/* Add from PDP panel (uses selected grind) */
async function addFromPDP(handle) {
  const p = window.PRODUCTS && window.PRODUCTS[handle];
  if (!p || !p.variantId) return;
  const grind = document.querySelector('#pdpGrindSelect .grind-btn.active')?.textContent || 'Whole Bean';
  try {
    await shopifyFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: p.variantId, quantity: 1, properties: { Grind: grind } })
    });
    await refreshCart();
    closePDP();
    openCart();
  } catch (e) { console.error('Add from PDP failed:', e); }
}

function checkout() {
  window.location.href = '/checkout';
}

function waCheckout() {
  const cart = window._shopifyCart;
  if (!cart || !cart.items.length) return;
  const lines = cart.items.map(item => {
    const g = (item.properties && item.properties['Grind']) || 'Whole Bean';
    return `• ${item.product_title} — ${g} × ${item.quantity} — ${formatRp(item.line_price)}`;
  }).join('\n');
  const total = formatRp(cart.total_price);
  const waNum = window.WA_NUMBER || '62817107090';
  window.open(`https://wa.me/${waNum}?text=${encodeURIComponent(`Halo TORU! Saya mau order:\n\n${lines}\n\nTotal: ${total}\n\nMohon konfirmasi. Terima kasih!`)}`, '_blank');
}

function orderWADirect(handle) {
  const p = window.PRODUCTS && window.PRODUCTS[handle];
  if (!p) return;
  // Product pages use #variantSelect; home PDP panel uses #pdpGrindSelect
  const activeBtn = document.querySelector('#variantSelect .grind-btn.active')
                 || document.querySelector('#pdpGrindSelect .grind-btn.active');
  const selection = activeBtn ? activeBtn.textContent.trim() : 'Whole Bean';
  // Use the selected button's data-price (real variant price) if available
  const rawPrice = (activeBtn && activeBtn.dataset.price) ? parseInt(activeBtn.dataset.price) : p.price;
  const price = formatRp(rawPrice);
  const waNum = window.WA_NUMBER || '62817107090';
  window.open(`https://wa.me/${waNum}?text=${encodeURIComponent(`Halo TORU! Saya mau order:\n\n• ${p.name} — ${selection} × 1 — ${price}\n\nMohon konfirmasi. Terima kasih!`)}`, '_blank');
}

/* ---- CART DRAWER UI ---- */
function openCart()  {
  document.getElementById('cartOverlay').classList.add('open');
  document.getElementById('cartDrawer').classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeCart() {
  document.getElementById('cartOverlay').classList.remove('open');
  document.getElementById('cartDrawer').classList.remove('open');
  document.body.style.overflow = '';
}

/* ---- PRODUCT DETAIL PANEL ---- */
function openPDP(handle) {
  const p = window.PRODUCTS && window.PRODUCTS[handle];
  if (!p) return;
  const s = p.specs || {};

  const specsHTML = `
    <div class="pdp-bean-header">
      <div class="pdp-bean-type">${s.type || 'Single Origin'}</div>
      <div class="pdp-bean-region">${s.region || ''}</div>
      <div class="pdp-bean-country">${s.country || ''}</div>
    </div>
    <div class="pdp-bean-table">
      <div class="pdp-bean-row"><span class="pdp-bean-key">Altitude</span><span class="pdp-bean-val">${s.altitude || '—'}</span></div>
      <div class="pdp-bean-row"><span class="pdp-bean-key">Process</span><span class="pdp-bean-val">${s.process || '—'}</span></div>
      <div class="pdp-bean-row"><span class="pdp-bean-key">Varietal</span><span class="pdp-bean-val">${s.varietal || '—'}</span></div>
      <div class="pdp-bean-row"><span class="pdp-bean-key">Roast</span><span class="pdp-bean-val">${s.roast || '—'}</span></div>
    </div>`;

  const notes = Array.isArray(p.notes) ? p.notes : [];
  const notesHTML = notes.map(n => `<span class="pdp-note">${n}</span>`).join('');

  const ymalHandles = (Array.isArray(p.ymal) && p.ymal.length > 0)
    ? p.ymal
    : Object.keys(window.PRODUCTS).filter(h => {
        if (h === handle) return false;
        const y = window.PRODUCTS[h];
        if (!y || !y.tab) return false;
        const pTab = p.tab ? p.tab.split(',')[0].trim() : 'filter';
        return y.tab.split(',').map(s => s.trim()).includes(pTab);
      }).slice(0, 3);
  const ymalHTML = ymalHandles.map(yh => {
    const y = window.PRODUCTS[yh];
    if (!y) return '';
    return `<div class="ymal-card" onclick="openPDP('${yh}')">
      <div class="ymal-img" style="background:${y.bgGrad || '#111'}">${y.image ? `<img src="${y.image}" alt="${y.name}" style="width:100%;height:100%;object-fit:cover;">` : (y.icon || '☕')}</div>
      <div class="ymal-body">
        <div class="ymal-origin">${y.origin || ''}</div>
        <div class="ymal-name">${y.name}</div>
        <div class="ymal-price">${formatRp(y.price)} <small style="font-size:10px;color:var(--muted);font-weight:400;font-family:var(--font-b)">/ ${y.weight || '200g'}</small></div>
        <button class="ymal-add" onclick="event.stopPropagation();quickAdd('${yh}')">+ Add to Cart</button>
      </div>
    </div>`;
  }).join('');

  const descParagraphs = (p.desc || '').split('\n\n').map(t => `<p style="margin-bottom:12px">${t}</p>`).join('');
  const badgeHTML = p.badgeText ? `<span class="pdp-badge pdp-badge-dark" style="${p.badgeStyle || ''}">${p.badgeText}</span>` : '';
  const heroContent = p.image
    ? `<img src="${p.image}" alt="${p.name}" style="position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:0;" /><div class="pdp-hero-bg" style="background:rgba(0,0,0,0.2)"></div>`
    : `<div class="pdp-hero-bg" style="background:${p.bgGrad || '#111'}"></div><div class="pdp-hero-icon">${p.icon || '☕'}</div>`;

  document.getElementById('pdpBody').innerHTML = `
    <div class="pdp-hero" style="position:relative;">
      ${heroContent}
      <div class="pdp-hero-badges" style="z-index:2">${badgeHTML}<span class="pdp-badge pdp-badge-dark">${p.process || ''}</span></div>
    </div>
    <div class="pdp-content">
      <div class="pdp-origin-label">${p.origin || ''}</div>
      <div class="pdp-name">${p.name}</div>
      <div class="pdp-notes-row">${notesHTML}</div>
      <div class="pdp-price-row">
        <div class="pdp-price">${formatRp(p.price)} <small>/ ${p.weight || '200g'}</small></div>
        <div class="pdp-grind-select" id="pdpGrindSelect">
          <button class="grind-btn active" onclick="selectGrind(this)">Whole Bean</button>
          <button class="grind-btn" onclick="selectGrind(this)">Espresso Grind</button>
          <button class="grind-btn" onclick="selectGrind(this)">Filter Grind</button>
          <button class="grind-btn" onclick="selectGrind(this)">Batch Brew Grind</button>
          <button class="grind-btn" onclick="selectGrind(this)">Cold Brew Grind</button>
        </div>
      </div>
      <div class="pdp-cart-row">
        <button class="pdp-add-btn" onclick="addFromPDP('${handle}')">+ Add to Cart</button>
        <button class="pdp-wa-btn" onclick="orderWADirect('${handle}')">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
          Order via WA
        </button>
      </div>
      <div class="pdp-bean-info">${specsHTML}</div>
      <div class="pdp-section-title">About This Coffee</div>
      <div class="pdp-desc">${descParagraphs}</div>
    </div>
    ${ymalHTML.length ? `<div class="pdp-ymal"><div class="pdp-ymal-title">You May Also Like</div><div class="pdp-ymal-grid">${ymalHTML}</div></div>` : ''}`;

  document.getElementById('pdpOverlay').classList.add('open');
  document.getElementById('pdpPanel').classList.add('open');
  document.getElementById('pdpBody').scrollTop = 0;
  document.body.style.overflow = 'hidden';
}

function closePDP() {
  document.getElementById('pdpOverlay').classList.remove('open');
  document.getElementById('pdpPanel').classList.remove('open');
  document.body.style.overflow = '';
}

function selectGrind(btn) {
  btn.closest('.pdp-grind-select').querySelectorAll('.grind-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
}

/* ---- MOBILE MENU ---- */
function toggleMenu() {
  var menu    = document.getElementById('mobileMenu');
  var overlay = document.getElementById('mobMenuOverlay');
  var isOpen  = menu.classList.contains('open');
  menu.classList.toggle('open');
  if (overlay) overlay.classList.toggle('open', !isOpen);
  document.body.style.overflow = isOpen ? '' : 'hidden';
}
function closeMenu() {
  var menu    = document.getElementById('mobileMenu');
  var overlay = document.getElementById('mobMenuOverlay');
  menu.classList.remove('open');
  if (overlay) overlay.classList.remove('open');
  document.body.style.overflow = '';
}
function toggleMobSub(btn) { btn.closest('.mob-item').classList.toggle('open'); }

/* ---- SMOOTH SCROLL ---- */
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const href = a.getAttribute('href');
    if (href === '#') return;
    const t = document.querySelector(href);
    if (t) { e.preventDefault(); window.scrollTo({ top: t.offsetTop - 72, behavior: 'smooth' }); }
  });
});

/* ---- PREDICTIVE SEARCH ---- */
let _searchTimer;

function openSearch() {
  document.getElementById('searchOverlay').classList.add('open');
  setTimeout(() => document.getElementById('searchInput').focus(), 50);
  document.body.style.overflow = 'hidden';
}
function closeSearch() {
  document.getElementById('searchOverlay').classList.remove('open');
  document.body.style.overflow = '';
  const inp = document.getElementById('searchInput');
  if (inp) inp.value = '';
  resetSearchResults();
}
function handleSearchOverlayClick(e) {
  if (e.target === e.currentTarget) closeSearch();
}
function resetSearchResults() {
  document.getElementById('searchResults').innerHTML = '';
  document.getElementById('searchFooter').style.display = 'none';
}
function setSearchQuery(q) {
  const inp = document.getElementById('searchInput');
  inp.value = q;
  inp.focus();
  inp.dispatchEvent(new Event('input'));
}

document.addEventListener('DOMContentLoaded', () => {
  const input = document.getElementById('searchInput');
  if (!input) return;
  input.addEventListener('keydown', e => {
    if (e.key === 'Enter' && input.value.trim()) {
      window.location = '/search?q=' + encodeURIComponent(input.value.trim());
    }
  });
  input.addEventListener('input', () => {
    clearTimeout(_searchTimer);
    const q = input.value.trim();
    if (q.length < 2) { resetSearchResults(); return; }
    document.getElementById('searchResults').innerHTML = '<div class="search-loading"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation:spin 0.8s linear infinite"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></svg> Searching...</div>';
    _searchTimer = setTimeout(() => _runSearch(q), 280);
  });
});

async function _runSearch(q) {
  const viewAll = document.getElementById('searchViewAll');
  if (viewAll) viewAll.href = '/search?q=' + encodeURIComponent(q);
  try {
    const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,article&resources[limit]=5`;
    const res = await fetch(url);
    const data = await res.json();
    _renderSearchResults(data.resources.results, q);
  } catch(e) {
    document.getElementById('searchResults').innerHTML = `<div class="search-empty">Something went wrong. <a href="/search?q=${encodeURIComponent(q)}" style="color:var(--gold)">Try full search →</a></div>`;
  }
}

function _renderSearchResults(results, q) {
  const container = document.getElementById('searchResults');
  const footer    = document.getElementById('searchFooter');
  const products  = (results && results.products) || [];
  const articles  = (results && results.articles) || [];

  if (!products.length && !articles.length) {
    container.innerHTML = `<div class="search-empty">No results for "<strong>${q}</strong>"<br><span style="font-size:12px;margin-top:6px;display:block">Try a different keyword or <a href="/collections/all" style="color:var(--gold)">browse all coffee</a></span></div>`;
    footer.style.display = 'none';
    return;
  }

  let html = '';
  if (products.length) {
    html += '<div class="search-section-label">Products</div>';
    products.forEach(p => {
      const imgSrc = p.image ? (p.image.url || p.image.src || p.image) : '';
      const img    = imgSrc ? `<img src="${imgSrc}" alt="${p.title}" />` : '☕';
      html += `<a href="${p.url}" class="search-result-item" onclick="closeSearch()">
        <div class="search-result-thumb">${img}</div>
        <div class="search-result-info">
          <div class="search-result-title">${p.title}</div>
          <div class="search-result-sub">${p.vendor || 'TORU Specialty Coffee'}</div>
        </div>
      </a>`;
    });
  }
  if (articles.length) {
    html += '<div class="search-section-label">Articles</div>';
    articles.forEach(a => {
      const img  = a.image ? `<img src="${a.image}" alt="${a.title}" />` : '📖';
      const body = (a.body || '').replace(/<[^>]+>/g, '').substring(0, 60);
      html += `<a href="${a.url}" class="search-result-item" onclick="closeSearch()">
        <div class="search-result-thumb">${img}</div>
        <div class="search-result-info">
          <div class="search-result-title">${a.title}</div>
          <div class="search-result-sub">${body}${body.length === 60 ? '…' : ''}</div>
        </div>
      </a>`;
    });
  }
  container.innerHTML = html;
  footer.style.display = 'flex';
}

/* spin keyframe injected once */
(function(){
  if (document.getElementById('_toru_spin')) return;
  const s = document.createElement('style');
  s.id = '_toru_spin';
  s.textContent = '@keyframes spin{to{transform:rotate(360deg)}}';
  document.head.appendChild(s);
})();

/* ---- ESC KEY ---- */
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') { closePDP(); closeCart(); closeMenu(); closeSearch(); }
});

/* ---- INIT ---- */
document.addEventListener('DOMContentLoaded', () => {
  refreshCart();
  // Tab init is handled by featured-products.liquid inline script
});